import { __decorate, __metadata } from "tslib";
import { AccelerationUnit } from '../../utils';
import { SerializableObject } from '../decorators';
import { SensorValue } from './SensorValue';
/**
 * Acceleration sensor value
 * @category Sensor Value
 */
let Acceleration = class Acceleration extends SensorValue {
  constructor(x = 0, y = 0, z = 0, unit = AccelerationUnit.METER_PER_SECOND_SQUARE) {
    super(x, y, z, unit, AccelerationUnit.METER_PER_SECOND_SQUARE);
  }
};
Acceleration = __decorate([SerializableObject(), __metadata("design:paramtypes", [Object, Object, Object, Object])], Acceleration);
export { Acceleration };